module.exports = __webpack_public_path__ + "img/AT0000002574513.5e9c2776.png";